export const getQueryStringByObject = (paramObject = {}) => (Object.keys(paramObject).map((key) => (`${key}=${paramObject[key]}`)).join('&'));
